import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const assignBot = (botId, userId, assign, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'ASSIGNING_BOT' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/bots/${botId}/users/${userId}`,
            null,
            {
              params: {
                'request-id': reqId,
                assign: assign,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'ASSIGNING_BOT_DONE',
              payload: {
                botId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(botId);
            }
          } else {
            dispatch({
              type: 'ASSIGNING_BOT_FAILED',
              payload: `Failed to assign bot`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'ASSIGNING_BOT_FAILED',
            payload: `Failed to assign bot`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'ASSIGNING_BOT_FAILED',
        payload: `Failed to assign bot`,
      });
    }
  };
};

export default assignBot;
